module.exports = __webpack_public_path__ + "img/UtilityTabSelected_ua.13878e28.webp";